import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const loaderSlice = createSlice({
    name: "isLoading",
    initialState: { value: true },
    reducers: {
        setIsLoader: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

const isGenerateMediaPlanLoadingSlice = createSlice({
    name: "isGenerateMediaPlanLoading",
    initialState: { value: false },
    reducers: {
        setIsGenerateMediaPlanLoading: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const mediaPlanListLoadingSlice = createSlice({
    name: "mediaPlanListLoading",
    initialState: { value: false },
    reducers: {
        setMediaPlanListLoading: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

export const { setIsLoader } = loaderSlice.actions;
export const { setIsGenerateMediaPlanLoading } =
    isGenerateMediaPlanLoadingSlice.actions;
export const { setMediaPlanListLoading } =
    mediaPlanListLoadingSlice.actions;

export const loadingReducer = loaderSlice.reducer;
export const isGenerateMediaPlanLoadingReducer =
    isGenerateMediaPlanLoadingSlice.reducer;
export const mediaPlanListLoadingReducer =
    mediaPlanListLoadingSlice.reducer;